// extracted by mini-css-extract-plugin
export default {"shadow-box":"FLN1Np-R5aoesDrokc5nHA=="};